module.exports = __webpack_public_path__ + "img/wendie-renard.21c23d4b.png";